export class ErrorBase extends Error {
    constructor(message?: string) {
        super(message);

        this.name = (this.constructor as typeof ErrorBase).errorName;
        if (!this.message) {
            this.message = (this.constructor as typeof ErrorBase).defaultMessage;
        }
    }

    static get defaultMessage(): string {
        return '';
    }

    static get errorName(): string {
        return '';
    }
}
